var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose } from 'class-transformer';
import { IsEnum, IsUUID } from 'class-validator';
import { Role } from '../../roles/index.js';
export class BackendResendInviteMailDto {
    keycloakUserId;
    officeLocationId;
    /** The invited Person's role; the verify mail speaks to it (#1823). */
    role;
}
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], BackendResendInviteMailDto.prototype, "keycloakUserId", void 0);
__decorate([
    IsUUID('4'),
    Expose(),
    __metadata("design:type", String)
], BackendResendInviteMailDto.prototype, "officeLocationId", void 0);
__decorate([
    IsEnum(Role),
    Expose(),
    __metadata("design:type", String)
], BackendResendInviteMailDto.prototype, "role", void 0);
//# sourceMappingURL=backend-resend-invite-mail.dto.js.map